<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/trainers',
          title: 'Trainers'
        },
        {
          href: canonicalPaths.relative,
          title: trainerPerson.name
        }
      ]"
      :value="heroSection"
    >
      <template v-if="trainerPage.hero_section.cta" #cta>
        <HeroCta :value="trainerPage.hero_section.cta" />
      </template>
    </HeroSection>

    <PersonSection
      :person="trainerPerson"
      :value="{}"
      class="mb-16 hero-section hero-below-offset"
    />

    <v-lazy>
      <OccasionsSection
        :banner="banner"
        :filters="{ deliveryMethod: false, who: false }"
        :filters-value="{ who: trainerPerson.code }"
        :value="classesSection"
        :what-products="whatProducts"
        class="mb-16"
      />
    </v-lazy>

    <DividerSection class="mb-16" />

    <ContactCtaSection :value="trainerPage.contact_cta_section" class="mb-16" />
  </div>
</template>

<script setup lang="ts">
import type { components } from '#root/types/directus'
import type { TrainerPage } from '#root/types/trainer-page'
import { computed } from 'vue'
import { usePageContext } from '#root/renderer/usePageContext'
import { useProvideDeliveryMethodsStore } from '#root/lib/useDeliveryMethodsStore'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'

const props = defineProps<{
  banner: components['schemas']['ItemsBanners'] | undefined
  deliveryMethods: components['schemas']['ItemsDeliveryMethods'][]
  trainerPage: TrainerPage
  trainerPerson: components['schemas']['ItemsPersons']
}>()

useProvideDeliveryMethodsStore(props.deliveryMethods)
useProvideTrainerPersonsStore([])

const { canonicalPaths } = usePageContext()
const heroSection = computed(() => {
  const section = Object.assign({}, props.trainerPage.hero_section)
  section.title = props.trainerPerson.name ?? ''
  section.paragraph = props.trainerPerson.title ?? ''
  return section
})
const classesSection = computed(() => {
  const section = Object.assign({}, props.trainerPage.classes_section)
  section.title = `Upcoming from ${props.trainerPerson.name}`
  return section
})
const whatProducts = computed(() => {
  return (
    props.trainerPerson.products
      ?.filter(
        (
          product
        ): product is {
          products_id: components['schemas']['ItemsProducts']
        } =>
          typeof product === 'object' &&
          product !== null &&
          'products_id' in product &&
          product.products_id !== null &&
          typeof product.products_id === 'object'
      )
      .map(product => product.products_id) ?? []
  )
})
</script>
